module.exports = __webpack_public_path__ + "static/media/london_1.b2329694.png";